import { getModuleName } from '../../../config/moduleCatalog';

// `name` resolves from the shared module catalog at import time. A rename
// made via the Form Registry's Module Scope panel shows up here after a
// page refresh (this array is built once at load, not live-reactive) —
// Sidebar and the Form Registry itself pick up renames immediately instead.
export const coreModules = [
  {
    id: 'livestock-population',
    name: getModuleName('livestock-population'),
    description: 'Population records',
    path: '/livestock-population',
    status: '3 Alerts',
    statusType: 'alert',
    records: 0,
    iconKey: 'livestock',
    lastValidated: '12-09-2025',
  },
  {
    id: 'markets-trade',
    name: getModuleName('markets-trade'),
    description: 'Market registry, prices and trade intelligence',
    path: '/markets-trade',
    status: '3 Alerts',
    statusType: 'alert',
    records: 0,
    iconKey: 'markets',
    lastValidated: '08-09-2025',
  },
  {
    id: 'infrastructure',
    name: getModuleName('infrastructure'),
    description: 'Facilities registry and service records',
    path: '/infrastructure',
    status: '3 Alerts',
    statusType: 'alert',
    records: 0,
    iconKey: 'infrastructure',
    lastValidated: '10-09-2025',
  },
  {
    id: 'workforce-institutional',
    name: getModuleName('workforce-institutional'),
    description: 'Workers, cooperatives and deployments',
    path: '/workforce-institutional',
    status: '2 Alerts',
    statusType: 'alert',
    records: 0,
    iconKey: 'workforce',
    lastValidated: '05-09-2025',
  },
  {
    id: 'planning-reporting',
    name: getModuleName('planning-reporting'),
    description: 'Activities, milestones and reports',
    path: '/planning-reporting',
    status: '2 Alerts',
    statusType: 'alert',
    records: 0,
    iconKey: 'planning',
    lastValidated: '15-09-2025',
  },
  {
    id: 'conflicts-dispute',
    name: getModuleName('conflicts-dispute'),
    description: 'Conflict records and dispute workflows',
    path: '/conflicts-dispute',
    status: '2 Alerts',
    statusType: 'alert',
    records: 0,
    iconKey: 'conflicts',
    lastValidated: '03-09-2025',
  },
  {
    id: 'animal-identification',
    name: getModuleName('animal-identification'),
    description: 'Livestock identification and movement tracking',
    path: '/animal-identification',
    status: '2 Alerts',
    statusType: 'alert',
    records: 0,
    iconKey: 'animalId',
    lastValidated: '11-09-2025',
  },
  {
    id: 'animal-health',
    name: getModuleName('animal-health'),
    description: 'Disease surveillance and vaccination records',
    path: '/animal-health',
    status: '3 Alerts',
    statusType: 'alert',
    records: 0,
    iconKey: 'animalHealth',
    lastValidated: '14-09-2025',
  },
];
